export default "__VITE_ASSET__oy3dcLSq__"